import PropTypes from 'prop-types';
import React from 'react';
import { Checkbox, FormGroup } from 'react-bootstrap';
import './CheckboxFormGroup.css';

const isError = (error, touched) => (error && touched ? 'error' : null);

// eslint-disable-next-line object-curly-newline
const CheckboxFormGroup = ({ label, meta, input, required, ...props }) => (
  <FormGroup validationState={isError(meta.error, meta.touched)}>
    <Checkbox {...input} {...props} checked={input.value} className="big-checkbox">{label}</Checkbox>
  </FormGroup>
);

CheckboxFormGroup.defaultProps = {
  label: '',
  meta: {},
  input: {},
  required: false,
};

CheckboxFormGroup.propTypes = {
  label: PropTypes.string,
  required: PropTypes.bool,
  meta: PropTypes.shape({}),
  input: PropTypes.shape({}),
};

export default CheckboxFormGroup;



// WEBPACK FOOTER //
// ./src/components/Forms/CheckboxFormGroup/CheckboxFormGroup.jsx